import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'
import { Text } from '@/components/ui/text'

import { cx } from '@/libs/cva'
import { toIdr } from '@/libs/utils/format'

export const Route = createFileRoute('/_app/report/cash-flow')({
  component: Component,
})

function Component() {
  return (
    <PageLayout.Root>
      <PageLayout.Header
        breadcrumbs={[
          ['/report', 'Laporan'],
          ['/report/cash-flow', 'Arus Kas'],
        ]}
      />
      <PageCard.Root>
        <PageCard.Header
          title="Laporan Arus Kas"
          desc="Laporan pergerakan uang masuk dan keluar dari transaksi dalam periode tertentu."
        />
        <PageCard.Content>
          <div
            className="grid pt-4"
            style={{
              gridTemplateColumns: 'repeat(2, auto)',
            }}
          >
            <Row level={1} label="Aktivitas Operasional" />
            {/*  */}
            <Row level={2} label="Penerimaan dari pelanggan" className="mt-4" />
            <Row level={3} label="Penjualan" value={toIdr(10_000)} />
            <Row
              level={2}
              label="Total Penerimaan dari pelanggan"
              value={toIdr(10_000)}
              className="mb-4"
            />
            {/*  */}
            <Row level={2} label="Pembayaran ke pemasok" className="mt-4" />
            <Row
              level={2}
              label="Total Pembayaran ke pemasok"
              value={toIdr(0)}
              className="mb-4"
            />
            {/*  */}
            <Row
              level={2}
              label="Penerimaan/(Pengeluaran) Operasional"
              className="mt-4"
            />
            <Row level={3} label="Listrik" value={['(', toIdr(10_000), ')'].join('')} />
            <Row level={3} label="Air" value={['(', toIdr(10_000), ')'].join('')} />
            <Row
              level={2}
              label="Total Penerimaan/(Pengeluaran) Operasional"
              value={toIdr(0)}
              className="mb-4 border-none"
            />
            {/*  */}
            <Row
              level={1}
              label="Arus Kas Dari Aktivitas Operasional"
              value={toIdr(10_000)}
              className="mb-8"
            />
            {/*  */}
            <Row level={1} label="Saldo Kas Awal Periode" value={toIdr(0)} />
            <Row level={1} label="Kenaikan (Penurunan) Kas" value={toIdr(10_000)} />
            <Row level={1} label="Saldo Kas Akhir Periode" value={toIdr(10_000)} />
          </div>
        </PageCard.Content>
      </PageCard.Root>
    </PageLayout.Root>
  )
}

interface RowProps {
  className?: string
  label: string
  value?: string
  level: 1 | 2 | 3
}

function Row({ className, label, value, level }: RowProps) {
  return (
    <div
      className={cx(
        'col-span-full grid grid-cols-subgrid gap-4 border-b px-6 py-2',
        {
          ['border-none bg-ui-bg-base-pressed [&>*]:font-semibold']: level === 1,
          ['pl-8 [&>*]:font-semibold']: level === 2,
          ['pl-12']: level === 3,
        },
        className
      )}
    >
      <Text>{label}</Text>
      <Text className="text-right">{value}</Text>
    </div>
  )
}
